import camelcaseKeys from 'camelcase-keys';

export function camelCaseResponse<T extends { readonly [key: string]: any }>(jsonObject: T): T {
	return camelcaseKeys<T>(jsonObject, {
		deep: true,
		exclude: [
			/ /, // Matches any key containing a space
			/^(?:[^-]*-){3}/, // Matches any key with at least three hyphens
		],
	});
}
